import "./Footer.css";
import { BsLinkedin, BsEnvelopeAtFill, BsTelephoneFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import { useTranslation } from "react-i18next";

export const Footer = () => {
  const { t } = useTranslation();
  return (
    <>
      <footer className="footerContainer">
        <div className="footerLeft">
          <Link
            className="iconStyle"
            to={"https://www.linkedin.com/company/vh-buildup-bvba/"}
            target="_blank"
          >
            <BsLinkedin
              size={30}
              data-tooltip-id="linkedin"
              data-tooltip-content="LinkedIn Profile"
            />
          </Link>
          <Link
            className="iconStyle"
            to={"mailto:info@vhbuildup.be"}
          >
            <BsEnvelopeAtFill
              size={30}
              data-tooltip-id="email"
              data-tooltip-content="E-mail : info@vhbuildup.be"
            />
          </Link>
          <Link
            className="iconStyle"
            to={"tel:+32 473 40 35 96"}
          >
            <BsTelephoneFill
              size={30}
              data-tooltip-id="tel"
              data-tooltip-content="Tel : +32 473 40 35 96"
            />
          </Link>
        </div>
        <div className="footerRight">
          <span>
            {t("footer.copy", { currentYear: new Date().getFullYear() })}
          </span>
        </div>
        <div>
          <span>
            {t("footer.dev")}{" "}
            <Link
              className="link-to-dev"
              to={"https://landerdekesel.com/"}
              target="_blank"
            >
              LDK
            </Link>
          </span>
        </div>
        <Tooltip id="linkedin" />
        <Tooltip id="email" />
        <Tooltip id="tel" />
      </footer>
    </>
  );
};
